import { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import {
  getFranchiseByCode,
  setOpenClaimDataStep,
  setStepsArray,
} from 'store/modules/openClaim/actions';
import { globalContext } from 'context/global';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { ReactSelectFlora } from 'components/ReactSelectFlora';
import { getCoverageListByTypePDV } from 'store/modules/coverage/actions';
import { Select } from 'types/Select';
import { getStoreList } from 'store/modules/stores/actions';
import Descriptions from '../components/Descriptions';
import ButtonContainer from '../components/ButtonContainer';
import { Wrapper, DescriptionsPlaceholder, Space } from './styles';
import { Label } from '../sharedStyles';
import useModalSaveDraft from '../useModalSaveDraft';

export const Step1 = (): JSX.Element => {
  const history = useHistoryWithHost();
  const {
    containerContext: { user },
  } = useContext(globalContext);

  const [selects, setSelects] = useState<any>({
    lojas: null,
    tipos: null,
  });
  const [optionsLojas, setOptionsLojas] = useState<Select[]>([]);
  const [optionsTipos, setOptionsTipos] = useState([]);

  const { savingDraft, setSavingDraft } = useModalSaveDraft('step1');

  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  const { coverageList } = useSelector(
    (state: ApplicationState) => state.coverage,
  );
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const { storeList } = useSelector((state: ApplicationState) => state.stores);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStoreList());
  }, [dispatch]);

  const onChangeSelect = (type: string, value: any) => {
    if (type === 'tipos' && stateClaim.coverage) {
      setSelects({ ...selects, [type]: value });
    } else if (type === 'lojas' && user) {
      setSelects({ ...selects, [type]: value });
      dispatch(getFranchiseByCode(value.value, cpId));
    }
  };
  const onClickForward = () => {
    if (!savingDraft) {
      setSavingDraft(true);
      if (stateClaim.step.step1) {
        let newStepsArray = [...stateClaim.stepsArray]; // esperado é [1,5]
        if (stateClaim.step.step1.lojas !== selects.lojas) {
          // apagar campos do passo 3 caso a loja mude
          dispatch(setOpenClaimDataStep(null, 'step3', 'stay'));
          newStepsArray = [...newStepsArray, 3];
        }
        if (stateClaim.step.step1.tipos !== selects.tipos) {
          // apagar campos do passo 3 caso a loja mude
          dispatch(setOpenClaimDataStep(null, 'step4', 'stay'));
          newStepsArray = [...newStepsArray, 4];
        }
        newStepsArray = [...new Set(newStepsArray)];
        newStepsArray.sort((a, b) => {
          return a - b;
        });
        dispatch(setStepsArray(newStepsArray));
      }
      dispatch(setOpenClaimDataStep(selects, 'step1', 'forward')); // atualizacao do state no redux deve ocorrer apenas ao avancar
    }
  };

  const onClickCancel = () => {
    history.push('/');
  };

  useEffect(() => {
    // para recordar valores
    if (
      stateClaim.step.step1 !== null &&
      selects.lojas === null &&
      selects.tipos === null
    ) {
      setSelects({
        lojas: stateClaim.step.step1.lojas,
        tipos: stateClaim.step.step1.tipos,
      });
      dispatch(getFranchiseByCode(stateClaim.step.step1?.lojas?.value, cpId));
    }
  }, [selects, stateClaim.step.step1, cpId]);

  useEffect(() => {
    if (stateClaim.franchise && selects.lojas) {
      dispatch(getCoverageListByTypePDV(stateClaim.franchise.typePDV));

      setSelects({
        ...selects,
        lojas: {
          ...selects.lojas,
          data: stateClaim.franchise,
        },
      });
    }
  }, [stateClaim.franchise]);

  useEffect(() => {
    if (storeList.length > 0 && optionsLojas.length === 0) {
      const newOptionsLojas = storeList.map(loja => ({
        label: `${loja.code} - ${loja.name}`,
        value: loja.code,
        data: loja,
      }));
      setOptionsLojas(newOptionsLojas);
      if (newOptionsLojas.length === 1) {
        setSelects((prevSelects: any) => {
          return {
            ...prevSelects,
            lojas: newOptionsLojas[0],
          };
        });
        dispatch(getFranchiseByCode(newOptionsLojas[0].value, cpId));
      }
    }
  }, [storeList, optionsLojas, cpId]);

  useEffect(() => {
    if (coverageList.length > 0) {
      const newOptionsTipos: any = [];
      coverageList.forEach((tipo: any, index: number) => {
        newOptionsTipos[index] = {
          label: tipo.name,
          options: [],
        };
        tipo.subCoverage.forEach((subtipo: any, subindex: number) => {
          newOptionsTipos[index].options[subindex] = {
            label: subtipo.name,
            value: subtipo.id,
            data: subtipo,
          };
        });
      });
      setOptionsTipos(newOptionsTipos);
    }
  }, [coverageList]);

  return (
    <Wrapper>
      <Label>
        Escolha aqui a loja da ocorrência{' '}
        <span>
          <span>*</span> Campos obrigatórios para abertura de sinistro
        </span>
      </Label>
      <ReactSelectFlora
        label="Lojas:"
        type="lojas"
        options={optionsLojas}
        value={selects.lojas}
        onChangeSelect={onChangeSelect}
        required
      />
      <Space />
      <Label>Escolha aqui o tipo de sinistro</Label>
      <ReactSelectFlora
        label="Tipos de sinistros:"
        type="tipos"
        options={optionsTipos}
        value={selects.tipos}
        onChangeSelect={onChangeSelect}
        disabled={optionsTipos.length === 0}
        isLoading={selects.lojas && optionsTipos.length === 0}
        required
      />
      <Space />
      {selects.tipos && selects.tipos.data.help.length === 2 && (
        <Descriptions
          whatIs={selects.tipos.data.help[0]}
          whatIsnt={selects.tipos.data.help[1]}
        />
      )}
      {!selects.tipos && <DescriptionsPlaceholder />}
      <ButtonContainer
        onClickCancel={onClickCancel}
        onClickForward={onClickForward}
        disabled={!(selects?.lojas?.data?.cnpj && selects.tipos)}
      />
    </Wrapper>
  );
};
